interface MakeMediaQueryProps {
  maxWidth?: number;
  minWidth?: number;
  maxHeight?: number;
  minHeight?: number;
}
const makeMediaQuery = ({
  maxWidth, minWidth, minHeight, maxHeight,
}: MakeMediaQueryProps) => (
  str: TemplateStringsArray, ...args: any
) => {
  const minWidthQuery = minWidth ? `(min-width: ${minWidth}px)` : '';
  const maxWidthQuery = maxWidth ? `(max-width: ${maxWidth}px)` : '';
  const minHeightQuery = minHeight ? `(min-height: ${minHeight}px)` : '';
  const maxHeightQuery = maxHeight ? `(max-height: ${maxHeight}px)` : '';
  const query = [
    minWidthQuery, maxWidthQuery, minHeightQuery, maxHeightQuery,
  ].filter((q) => !!q).join(' and ');
  const content = str.map((s, i) => `${s}${args[i] ?? ''}`).join('');
  return `@media ${query} {${content}}`;
};

const media = {
  /** @media (max-width: 1400px) */
  xxl: makeMediaQuery({ maxWidth: 1400 }),
  /** @media (max-width: 1200px) */
  xl: makeMediaQuery({ maxWidth: 1200 }),
  /** @media (max-width: 992px) */
  lg: makeMediaQuery({ maxWidth: 992 }),
  /** @media (max-width: 768px) */
  md: makeMediaQuery({ maxWidth: 768 }),
  /** @media (max-width: 576px) */
  sm: makeMediaQuery({ maxWidth: 576 }),
  /** @media (max-width: 400px) */
  xs: makeMediaQuery({ maxWidth: 400 }),

  height: {
    /** @media (max-height: 823px) */
    lg: makeMediaQuery({ maxHeight: 823 }),
    /** @media (max-height: 768px) */
    md: makeMediaQuery({ maxHeight: 768 }),
    /** @media (max-height: 667px) */
    sm: makeMediaQuery({ maxHeight: 667 }),
  },
};

export const matchDeviceSize = (device: 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs') => {
  const query = media[device]``.replace(/\{|\}|@media/g, '');
  return window.matchMedia(query).matches;
};

export default media;
